/**
 * Admin-ServiceOrderDetailsAdmin Queries
 */

import gql from 'graphql-tag'
import { graphql } from 'react-apollo'

export const getOrderQuery = gql`
  query GetOrder($orderId: String!) {
    orderQuery: getServiceOrder(orderId: $orderId) {
      id
      shortId: short_id
      charge_id
      name
      category
      originalOrder: original_order
      totalAmount: total_amount
      projectName: project_name
      taxFee: tax_fee
      taxGst: tax_gst
      taxPst: tax_pst
      taxAmount: tax_amount
      paymentMethod: payment_method
      invoiceLink: invoice_link
      trackingNumber: tracking_number
      deliveredDate: delivered_date
      isDelivered: is_delivered
      imported
      billingFirstName: billing_address_first_name
      billingLastName: billing_address_last_name
      billingStreet: billing_address_street
      billingApartment: billing_address_apartment
      billingCountry: billing_address_country
      billingStateProvince: billing_address_state_province
      billingCity: billing_address_city
      billingZipCode: billing_address_zip_code
      weight
      shippingAmount: shipping_amount
      files
      currency {
        shortName: short_name
      }
      orderDate: created_at
      payment: payment_object {
        stripeCharge {
          cardData: source {
            name
            last4
            brand
            expMonth: exp_month
            expYear: exp_year
          }
        }
        paypalCharge {
          id
        }
      }
      cart {
        name
        price
        description
        designImage: design_image
        designName: design_name
        designId: design_id
        designCode: design_code
      }
      status
      email
      user
      author {
        shortId: short_id
      }
      placedAuthor: placedBy {
        firstName: first_name
        lastName: last_name
      }
    }
  }
`

export const saveDeliveryMutation = graphql(
  gql`
    mutation saveDeliveryServiceOrder($orderId: String!, $isDeliver: Boolean, $date: String) {
      saveDeliveryServiceOrder(orderId: $orderId, isDeliver: $isDeliver, date: $date) {
        message
      }
    }
  `,
  {
    name: 'saveDeliverDate'
  }
)



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/OrderServiceDetails/data.ts